interface Configuration {
  lob: string;
  coverage: string;
  signinUrl: string;
  brandmarkAffiliate: string;
  brandmarkVariant: string;
  languages: string;
}

interface HeaderData {
  lob: string;
  coverage: string;
  signinUrl: string;
  brandmarkAffiliate: string;
  brandmarkVariant: string;
  languages: string;
}

export const getHeaderContent = (
  configuration: Configuration[],
  lob: string,
  coverage: string
): HeaderData | undefined => {
  if (!lob && !coverage) {
    return undefined;
  }
  return configuration?.find((content) => {
    if (content.lob !== lob) {
      return false;
    }
    // Check if coverage is defined before processing
    if (!content.coverage) {
      return false;
    }
    // Check if coverage matches exactly or is included in the comma-separated list
    const coverageList = content.coverage.split(',').map((c) => c.trim());
    return (
      content.coverage === coverage ||
      coverageList.includes(coverage) ||
      content.coverage === 'ALL'
    );
  });
};
